import { PermissionsEnum } from '@/auth/interfaces';
import { SaveTarjeta } from '../../shared/components';
import { useCheckPermissions } from '@/shared';

export interface CreateTarjetaPageInterface {}

const CreateTarjetaPage: React.FC<CreateTarjetaPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_tarjeta);


  return <SaveTarjeta titlePage="Crear Tarjeta" />;
};

export default CreateTarjetaPage;
